import prod from './prod';
import stage from './stage';
import dev from './dev';


let config: Config = {
    keycloak: {},
    hasura: {},
};

if (import.meta.env.MODE === 'production') {
    /* eslint @typescript-eslint/no-var-requires: "off" */
    config = prod;
} else if (import.meta.env.MODE === 'stage') {
    /* eslint @typescript-eslint/no-var-requires: "off" */
    config = stage;
} else if (import.meta.env.MODE === 'development') {
    /* eslint @typescript-eslint/no-var-requires: "off" */
    config = dev;
}

export default config;
